import { useAuth0 } from '@auth0/auth0-react';
import {
  tokenManager,
  userManager,
  UserProvider as CoreUserProvider,
} from '@oppy/omniv2-core';
import { type ReactNode, useEffect, useState } from 'react';

import {
  decodeJWTPayload,
  mapAuth0ToUser,
} from '../auth0-provider/auth0-utils';

// eslint-disable-next-line func-style
function Auth0UserSync({ children }: { children: ReactNode }) {
  const { isLoading, user, getAccessTokenSilently } = useAuth0();

  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isLoading) return;

    const init = async () => {
      try {
        const token = await getAccessTokenSilently();

        tokenManager.setTokenGetter(async () => await getAccessTokenSilently());

        const payload = decodeJWTPayload(token);

        if (user) {
          userManager.setCurrentUser(mapAuth0ToUser(user, payload));
        }
      } catch (e) {
        console.error('[Auth0 init]', e);
        userManager.clear();
      } finally {
        setReady(true);
      }
    };

    init();
  }, [isLoading, getAccessTokenSilently, user]);

  if (isLoading || !ready) {
    return <div>Chargement…</div>;
  }

  return <>{children}</>;
}

/**
 * UserProvider that wraps the core UserProvider with Auth0 sync.
 * This ensures all components using useUser/useCurrentUser from @oppy/omniv2-core work correctly.
 */
export default function UserProvider({ children }: { children: ReactNode }) {
  return (
    <CoreUserProvider>
      <Auth0UserSync>{children}</Auth0UserSync>
    </CoreUserProvider>
  );
}
